import "./ForgotPasswordSubmit.css";
import React from "react";
import PropTypes from "prop-types";
import { Form, Field } from "formik";
import { Button, FormText  } from "react-bootstrap";
import CustomInputComponent from "../CustomInputComponent";



const ForgotPasswordSubmit = ({ dirty, isSubmitting, error }) => (
      <div className="ForgotPasswordSubmit simple-form" style={{ minHeight: "73.65vh" }}>
            <Form>
                  <Field
                        autoFocus
                        type="text"
                        name="confirmationCode"
                        component={CustomInputComponent}
                  >
                        <FormText>
                              Please enter the confirmation code we sent to your
                              email address.
                        </FormText>
                  </Field>
                  <Field
                        type="password"
                        name="newPassword"
                        bssize="large"
                        component={CustomInputComponent}
                  />
                  <Field
                        type="password"
                        name="confirmNewPassword"
                        bssize="large"
                        component={CustomInputComponent}
                  />
                  <Button
                        block
                        type="submit"
                        bssize="large"
                  >
                        Submit
                  </Button>
            </Form>
      </div>
);

ForgotPasswordSubmit.propTypes = {
      dirty: PropTypes.bool,
      isSubmitting: PropTypes.bool
};

ForgotPasswordSubmit.defaultProps = {
      dirty: false,
      isSubmitting: false
};

export default ForgotPasswordSubmit;
